var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.active
    ? _c(
        "div",
        { staticClass: "snackbar-container" },
        [
          _c(
            "v-snackbar",
            {
              staticClass: "snackbar",
              attrs: { color: _vm.color, timeout: _vm.duration },
              model: {
                value: _vm.toggle,
                callback: function($$v) {
                  _vm.toggle = $$v
                },
                expression: "toggle"
              }
            },
            [
              _vm._v(" " + _vm._s(_vm.text) + " "),
              _c(
                "v-btn",
                {
                  attrs: { color: "white", text: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }